module.exports = __webpack_public_path__ + "img/o-povo-site.jpg";